module.exports = __webpack_public_path__ + "static/media/6S.79d2a613.png";